import { PaymentManagerContainer } from './paymentManager.styles';
import { Modal, Tabs } from 'antd';
import BillingInfo from './Billing/BillingInfo';
import InvoiceDetails from './Invoice/InvoiceDetails';
import { ReactComponent as CloseIcon } from "../../../../assets/svgs/icons/close-icon.svg";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';


const PaymentManager = () => {
    const [show, setShow] = useState<boolean>(true);
    const navigate = useNavigate();
    
    const handleCancel = () => {
        setShow(false);
        navigate('/')
    };

    const tabItems = [
        {
            label: <span>Billing</span>,
            key: "1",
            children: (
                <>
                    <BillingInfo />
                </>
            ),
        },
        {
            label: <span>Invoice</span>,
            key: "2",
            children: (
                <>
                    <InvoiceDetails />
                </>
            ),
        },
    ];


    return (
        <Modal
            centered
            open={show}
            className="batch_modal create_batch_modal quota_modal"
            onCancel={handleCancel}
            closeIcon={
                <CloseIcon key="CloseIcon" color="#ffffff" onClick={handleCancel} />
            }
            footer={null}
            style={{
                backgroundColor: "#36BDBE",
                width: "100%", // Adjust the width as per your need
                maxWidth: "100%", // Set maximum width if needed
            }}
        >
            <PaymentManagerContainer>
                <div className="table-container">
                    <div className="custom-tab-container">
                        <Tabs
                            defaultActiveKey="1"
                            items={tabItems}
                            key="1"
                            className="custom-tabs custom_payment_tabs"
                        ></Tabs>
                    </div>
                </div>
            </PaymentManagerContainer>
        </Modal>
    );
}

export default PaymentManager;
